import { MicrositeRecipientStatus } from '@nkr/enums/microsite-recipient-status';

export interface IMicrositeRecipientBulkDeactivationRequest {
    id: number,
    deactivationStatus: MicrositeRecipientStatus,
    dashRegistrationId: number,
    dashRegistrationEmail: string,
    donorOrigin: number,
    transplantDate: string,
    reason: string
}